import { render, staticRenderFns } from "./BlocoPesquisaFiltros.vue?vue&type=template&id=40c68d5f&lang=pug"
import script from "./BlocoPesquisaFiltros.vue?vue&type=script&lang=js"
export * from "./BlocoPesquisaFiltros.vue?vue&type=script&lang=js"
import style0 from "./BlocoPesquisaFiltros.vue?vue&type=style&index=0&id=40c68d5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports